import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

const SnowfallEffect = ({ enabled = true, snowflakeCount = 50 }) => {
  const [snowflakes, setSnowflakes] = useState([]);

  useEffect(() => {
    if (!enabled) return;

    // Generate snowflakes with random properties
    const flakes = Array.from({ length: snowflakeCount }, (_, i) => ({
      id: i,
      left: Math.random() * 100, // Random horizontal position (0-100%)
      animationDuration: 5 + Math.random() * 10, // Fall duration (5-15s)
      opacity: 0.3 + Math.random() * 0.7, // Opacity (0.3-1)
      size: 2 + Math.random() * 4, // Size (2-6px)
      delay: Math.random() * 5, // Start delay (0-5s)
      drift: -20 + Math.random() * 40, // Horizontal drift (-20 to 20px)
    }));

    setSnowflakes(flakes);
  }, [enabled, snowflakeCount]);

  if (!enabled) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        overflow: 'hidden',
      }}
    >
      {snowflakes.map((flake) => (
        <Box
          key={flake.id}
          sx={{
            position: 'absolute',
            top: '-10px',
            left: `${flake.left}%`,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            background: 'white',
            borderRadius: '50%',
            opacity: flake.opacity,
            boxShadow: '0 0 10px rgba(255, 255, 255, 0.8)',
            animation: `snowfall ${flake.animationDuration}s linear infinite`,
            animationDelay: `${flake.delay}s`,
            '@keyframes snowfall': {
              '0%': {
                transform: `translateY(0) translateX(0)`,
              },
              '100%': {
                transform: `translateY(100vh) translateX(${flake.drift}px)`,
              },
            },
          }}
        />
      ))}
      
      {/* Optional: Add some sparkle stars */}
      <style>
        {`
          @keyframes twinkle {
            0%, 100% { opacity: 0.3; }
            50% { opacity: 1; }
          }
        `}
      </style>
    </Box>
  );
};

export default SnowfallEffect;
